"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorPanelContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.ErrorPanelContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  padding: 25px 10px;
  border: 1px solid rgb(128, 128, 128);
  border-radius: 3px;

  max-height: 500px;
  overflow: auto;

  div:first-child {
    margin-right: 20px;
    flex-shrink: 0;
  }

  > p {
    margin-top: 10px;
  }
`;
//# sourceMappingURL=error-panel-container.js.map